export enum UserRoles{
    aguacate_operator = 'aguacate_operator',
    aguacate_client = 'aguacate_client',
    aguacate_retail_client = 'aguacate_retail_client',
    aguacate_retail_cashier = 'aguacate_retail_cashier',
}
